import React, { Component, Fragment } from 'react';
import { Loader } from 'semantic-ui-react';
import PropTypes from 'prop-types';


class Fetcher extends Component {
  componentDidMount() {
    const { fetchAction } = this.props;
    if (Array.isArray(fetchAction)) {
      fetchAction.forEach(func => func());
    } else {
      fetchAction();
    }
  }

  render() {
    const { isLoading, children, as } = this.props;

    return (
      <Fragment>
        {isLoading
          ? <Loader as={as} size="small" active inline="centered" className="fetcher-loader" />
          : <Fragment>{children}</Fragment>
         }
      </Fragment>
    );
  }
}

Fetcher.propTypes = {
  fetchAction: PropTypes.oneOfType([ // the Redux action to fetch the data
    PropTypes.func,
    PropTypes.arrayOf(PropTypes.func),
  ]).isRequired,
  isLoading: PropTypes.bool.isRequired,
  children: PropTypes.node,
  as: PropTypes.func,
};

Fetcher.defaultProps = {
  children: undefined,
  as: null,
};

export default Fetcher;



// WEBPACK FOOTER //
// ./src/components/reusable/Fetcher.js